export type StripeCheckoutSession = {
  provider: "stripe";
  client_secret: string;
  publishable_key: string;
  api_version?: string;
};

export type PendingStripeCheckoutSession = StripeCheckoutSession & {
  billingCustomerId: string;
  makePrimary: boolean;
};

export const STRIPE_CHECKOUT_SESSION_STORAGE_KEY = "scraperapi.stripe.checkout-session";

export function clearPendingStripeCheckoutSession(): void {
  try {
    window.sessionStorage.removeItem(STRIPE_CHECKOUT_SESSION_STORAGE_KEY);
  } catch {
    // Ignore unavailable browser storage.
  }
}

export function readPendingStripeCheckoutSession(
  expectedBillingCustomerId: string
): PendingStripeCheckoutSession | undefined {
  if (typeof window === "undefined") return undefined;

  try {
    const rawValue = window.sessionStorage.getItem(STRIPE_CHECKOUT_SESSION_STORAGE_KEY);
    if (!rawValue) return undefined;

    const value = JSON.parse(rawValue) as Partial<PendingStripeCheckoutSession>;
    if (
      value.provider !== "stripe"
      || typeof value.client_secret !== "string"
      || typeof value.publishable_key !== "string"
      || typeof value.makePrimary !== "boolean"
      || value.billingCustomerId !== expectedBillingCustomerId
    ) {
      clearPendingStripeCheckoutSession();
      return undefined;
    }

    return value as PendingStripeCheckoutSession;
  } catch {
    clearPendingStripeCheckoutSession();
    return undefined;
  }
}

export function savePendingStripeCheckoutSession(
  session: StripeCheckoutSession,
  makePrimary: boolean,
  billingCustomerId: string
): void {
  try {
    const value: PendingStripeCheckoutSession = {
      ...session,
      makePrimary,
      billingCustomerId
    };
    window.sessionStorage.setItem(STRIPE_CHECKOUT_SESSION_STORAGE_KEY, JSON.stringify(value));
  } catch {
    // Redirect recovery is unavailable when browser storage cannot be written.
  }
}
